import { createFileRoute, Outlet } from '@tanstack/react-router';

export function CollectionDetailRoute() {
  return <Outlet />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId')({
  component: CollectionDetailRoute,
});
